import { ProductColor } from '@aloft/toolkit-sui';

export const getPinColor = (status?: string): ProductColor => {
  switch (status?.toLowerCase()) {
    case 'active':
      return 'pinActive';
    case 'sold':
    case 'recently_sold':
      return 'pinSold';
    case 'pending':
      return 'pinPending';
    default:
      return 'pinOffMarket';
  }
};
